import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledMessagesContainer = styled(Flexbox)`
    height: 100%;
`

export const StyledMessagesScrollArea = styled.div(
    () => css`
        flex: 1;
        min-height: 0;
        position: relative;
        width: 100%;
    `
)

export const StyledMessagesBody = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px;
        min-height: 100%;
    `
)

export const StyledEmptyState = styled(Flexbox)(
    ({theme: {spacing, palette, typography}}) => css`
        height: 100%;
        padding: ${spacing * 4}px;
        ${typography.textMd};
        color: ${palette.neutral[400]};
        text-align: center;
        align-items: center;
        justify-content: center;
    `
)

export const StyledLoadMoreIndicator = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        padding: ${spacing * 2}px;
        text-align: center;
        ${typography.textSm};
        color: ${palette.neutral[500]};
    `
)
